import { dataPhoneCall } from 'dls-icons-data'
import { createIcon } from '../common'

const IconPhoneCall = /*#__PURE__*/createIcon(dataPhoneCall)
export default IconPhoneCall
